<script setup>
import { computed } from 'vue';
import StylingAndComfortFrameAgreement from './StylingAndComfortFrameAgreement';
import StylingAndComfortStockVehicle from './StylingAndComfortStockVehicle';
import StylingAndComfortStandard from './StylingAndComfortStandard';
import StylingAndComfortDW5 from './StylingAndComfortDW5';
import StylingAndComfortDW5V2 from './StylingAndComfortDW5V2';

import { useMainStore } from '@/store/index.js';
const store = useMainStore();

const props = defineProps({
  items: {
    type: Object,
    default: null,
  },
  images: {
    type: Object,
    required: true,
  },
  offerTemplate: {
    type: String,
    default: '',
    required: true,
  },
  specType: {
    type: String,
    default: '',
    required: true,
  },
  isFrameAgreement: {
    type: Boolean,
    default: false,
    required: true,
  },
  isDW5: {
    type: Boolean,
    default: false,
  },
  isDW5V2: {
    type: Boolean,
    default: false,
  },
});

const isSpecEB = computed(() => {
  return props.offerTemplate === `${String(store.market).toUpperCase()}_STANDARDA4X2EB`;
});

const checkIfStylingAndComfortFrameAgreement = computed(() => {
  return props.isFrameAgreement;
});

const checkIfStylingAndComfortStockVehicle = computed(() => {
  return props.specType === 'stock_vehicle';
});

const checkIfStylingAndComfortStandard = computed(() => {
  return props.specType !== 'stock_vehicle' && (!props.isDW5 && !props.isDW5V2);
});
</script>

<template>
  <StylingAndComfortFrameAgreement
    v-if="checkIfStylingAndComfortFrameAgreement"
    :items="props.items"
    :images="props.images"
    :is-spec-e-b="isSpecEB"
  />
  <StylingAndComfortStockVehicle
    v-else-if="checkIfStylingAndComfortStockVehicle"
    :items="props.items"
    :images="props.images"
    :is-spec-e-b="isSpecEB"
  />
  <StylingAndComfortStandard
    v-else-if="checkIfStylingAndComfortStandard"
    :items="props.items"
    :images="props.images"
    :is-spec-e-b="isSpecEB"
  />
  <StylingAndComfortDW5
    v-else-if="props.isDW5"
    :items="props.items"
    :images="props.images"
    :is-spec-e-b="isSpecEB"
  />
  <StylingAndComfortDW5V2
    v-else-if="props.isDW5V2"
    :items="props.items"
    :images="props.images"
    :is-spec-e-b="isSpecEB"
  />
</template>

<style scoped>
</style>
